import { recipientDetails } from "./recipientRedeucer";

export const recipient_action = (query) => async (dispatch) => {
    try {
        dispatch(recipientDetails(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};
